import { Box } from '@mui/material';
import { keyframes, styled } from '@mui/material/styles';

type FadeUpProps = {
  delay?: number;
};

const fadeUp = keyframes`
  0% {
    opacity: 0;
    transform: translateY(12px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const FadeUp = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'delay',
})<FadeUpProps>(({ delay = 0 }) => ({
  animation: `${fadeUp} 450ms cubic-bezier(0.22, 1, 0.36, 1) both`,
  animationDelay: `${delay}ms`,
}));
